import { constantTree } from "../../../core/events/ConstantTree";

export const upgradeBookingTree = constantTree({
    UpgradeBooking: {
        Back: "",
        Init: "",
        InitResult: "",
        Continue: {
            Click: ""
        },
        ProcessUpgradeOffers: ""
    }
})